import SpaceRoboticsPNG from "./SpaceRobotics.png";
import Non_CooperativeObjectPNG from "./Non_CooperativeObject.png";
import Non_CooperativeObjectMP4 from "./Non_CooperativeObject.mp4";
import RobotLatchPNG from "./RobotLatch.png";
import RobotLatchMP4 from "./RobotLatch.mp4";
import ControlCapturingPNG from "./ControlCapturing.png";
import ControlCapturingMP4 from "./ControlCapturing.mp4";
import DynamicBehaviorPredictionPNG from "./DynamicBehaviorPrediction.png";
import Picture1DrLiThumbJPG from "./Picture1DrLiThumb.jpg";

export const CurrentProjectList_contents = [
    {   link: "/CurrentProjects/Project7",
        text: "Development of Advanced Space Robotics Technologies to Enable Challenging In-Space Operations for ISAM and Space Logistics",
        image: SpaceRoboticsPNG,
    },
    {   link: "/CurrentProjects/Project1",
        text: "Development of A 3D Proximity-Operation Test System for On-Orbit Servicing a Non-Cooperative Object",
        image: Non_CooperativeObjectPNG,
        video: Non_CooperativeObjectMP4,
    },
    {   link: "/CurrentProjects/Project9",
        text: "AI-based Solutions to Allow Mobile Robots to Open Self-closing Doors and Plug in Standard Power Outlets for Charging",
        image: RobotLatchPNG,
        video: RobotLatchMP4,
    },
    {   link: "/CurrentProjects/Project12",
        text: "Optimal Attitude Profiling of A 12U Scientific CubeSat",
    },
    {   link: "/CurrentProjects/Project16",
        text: "Robot Control for Capturing a Non-cooperative Object",
        image: ControlCapturingPNG,
        video: ControlCapturingMP4,
    },
    {   link: "/CurrentProjects/Project28",
        text: "Physics-Enhanced Deep Learning for Fast-than-Real-Time Prediction of Dynamic Behavior of Space Robotic Systems",
        image: DynamicBehaviorPredictionPNG,
    },

    {   link: "/CurrentProjects/Project29",
        text: "Enhancing Human–Robot Interaction Safety in Manufacturing Using 3D Vision and Machine Learning Technologies",
        image: Picture1DrLiThumbJPG,
    },
];
